import React from 'react';
import { NavigationMenu } from '../ui/navigation-menu';
import NavLinkBtn from './components/NavLinkBtn';
import TrashNavLink from './components/TrashNavLink';
import { PATHS } from '@/constants/Paths';
import { Avatar, AvatarFallback } from '../ui/avatar';
import { NavLink } from 'react-router';
import { useGetMe } from '@/api/user.api';
import { UserType } from '@/types/auth/UserType';
import { API_URL } from '@/constants/Environment';
import { useAuth } from '@/hooks/useAuth';
import StyledButton from '../styled/StyledButton';
import { useTranslation } from '@/i18n';
import { useDistributorLabels } from '@/hooks/useDistributorLabels';
const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const { tNavbar } = useDistributorLabels();
  const { disconnectImpersonate } = useAuth();
  const { data: userData, isSuccess } = useGetMe();
  const initials: string =
    isSuccess && userData?.firstname && userData?.lastname
      ? userData.firstname[0] + userData.lastname[0]
      : 'Profil';

  const userType: UserType | null = isSuccess ? userData?.userType : null;

  const logo = isSuccess
    ? userType === UserType.Admin
      ? '/logo_raw.svg'
      : userType === UserType.Receiver
        ? userData.company?.imageUrl
        : userData.agency?.logo
    : null;

  return (
    <div className="md:sticky top-0 flex flex-col md:flex-row justify-between items-center w-full px-6 py-2 border border-gray-200 bg-white z-50">
      <div className="flex flex-col md:flex-row gap-4">
        <img src="/images/ypt-logo.png" className="h-10 w-auto" />
        <div className="gap-2">
          <NavigationMenu className="flex flex-col md:flex-row">
            {userType === UserType.Receiver && (
              <>
                <NavLinkBtn
                  path={PATHS.home.dashboard}
                  title={t('navbar.dashboard')}
                />
                <NavLinkBtn
                  path={PATHS.home.suppliers.list}
                  title={t('navbar.suppliers')}
                />
                <NavLinkBtn
                  path={PATHS.home.benefits.list}
                  title={t('navbar.benefits')}
                />
                <NavLinkBtn
                  path={PATHS.home.circuits.list}
                  title={t('navbar.circuits')}
                />
                <NavLinkBtn
                  path={PATHS.home.distributors.list}
                  title={t('navbar.distributors')}
                />
                <NavLinkBtn
                  path={PATHS.home.reservations.requests.list}
                  title={t('navbar.reservations')}
                />
                <NavLinkBtn
                  path={PATHS.home.stats.list}
                  title={t('navbar.stats')}
                />
              </>
            )}
            {userType === UserType.Distributor && (
              <>
                <NavLinkBtn
                  path={PATHS.distributors.dashboard}
                  title={t('navbar.dashboard')}
                />
                <NavLinkBtn
                  path={PATHS.distributors.receivers.list}
                  title={t('navbar.suppliers')}
                />
                <NavLinkBtn
                  path={PATHS.distributors.circuits.list}
                  title={t('navbar.circuits')}
                />
                <NavLinkBtn
                  path={PATHS.distributors.clients.list}
                  title={tNavbar()}
                />
                <NavLinkBtn
                  path={PATHS.distributors.estimates.list}
                  title={t('navbar.estimates')}
                />
                <NavLinkBtn
                  path={PATHS.distributors.stats.list}
                  title={t('navbar.stats')}
                />
              </>
            )}
            {userType === UserType.Admin && (
              <>
                <NavLinkBtn
                  path={PATHS.admin.dashboard}
                  title={t('navbar.dashboard')}
                />
                <NavLinkBtn
                  path={PATHS.admin.stats}
                  title={t('navbar.stats')}
                />
                <NavLinkBtn
                  path={PATHS.admin.receivers}
                  title={t('navbar.receivers')}
                />
                <NavLinkBtn
                  path={PATHS.admin.distributors}
                  title={t('navbar.distributors')}
                />
              </>
            )}
          </NavigationMenu>
        </div>
      </div>
      <div className="flex flex-row items-center gap-2">
        {userType === UserType.Admin && (
          <NavLink
            className="h-10 px-4 py-2 gap-2.5 rounded-md"
            to={`${API_URL}admin`}
            target="_blank"
          >
            {t('navbar.backoffice')}
          </NavLink>
        )}
        {userType === UserType.Receiver && <TrashNavLink />}
        {userData?.impersonatedBy !== undefined && (
          <StyledButton
            variant="link"
            className="p-0"
            title={t('navbar.back')}
            onClick={disconnectImpersonate}
          />
        )}
        <NavLink
          to={PATHS.profile}
          className="p-2 gap-4 rounded-4xl bg-brand-50 flex items-center hover:bg-brand-100 transition-colors"
          title={t('pages.profile.myAccount')}
        >
          {logo && <img className="h-10 w-auto" src={logo} alt="" />}
          <Avatar>
            <AvatarFallback className="w-10 h-10 bg-brand-600 text-sm leading-6 font-normal text-white">
              {initials}
            </AvatarFallback>
          </Avatar>
        </NavLink>
      </div>
    </div>
  );
};

export default Navbar;
